import { cast as castArray, intersperse } from './array';
import CMPError from '../cmp-error';
import { curry } from './function';
export class ElementDecorator {
    constructor(raw) {
        this.raw = raw;
    }
    on(event, fns) {
        for (const fn of castArray(fns)) {
            this.raw.addEventListener(event, fn);
        }
        return this;
    }
    click(fns) {
        return this.on('click', fns);
    }
    remove() {
        const parent = this.raw.parentNode;
        if (parent) {
            parent.removeChild(this.raw);
        }
        return this;
    }
    replace(elementDecorator) {
        const parent = this.raw.parentNode;
        if (!parent) {
            throw new CMPError('Cannot replace element');
        }
        parent.replaceChild(elementDecorator.raw, this.raw);
        return elementDecorator;
    }
    submit(fns) {
        return this.on('submit', fns);
    }
    appendChild(child) {
        this.raw.appendChild(child.raw);
        return this;
    }
}
const setAttributes = (element, attributes) => {
    for (const [key, attribute] of Object.entries(attributes)) {
        let value;
        if (Array.isArray(attribute)) {
            value = attribute.join(' ');
        }
        else if (typeof attribute === 'object') {
            value = Object.keys(attribute)
                .filter((key) => attribute[key])
                .join(' ');
        }
        else if (typeof attribute === 'boolean') {
            value = '';
        }
        else {
            value = '' + attribute;
        }
        element.setAttribute(key, value);
    }
};
const appendChildren = (element, children, doc) => {
    for (const child of children) {
        element.appendChild(typeof child === 'string' ? doc.createTextNode(child) : child.raw);
    }
};
const TRANSLATE_REG_EXP = /(%\{([^\}]+)\})/g;
export const translate = curry((i18n, key, replacements = {}) => {
    const children = i18n.t(key).split(TRANSLATE_REG_EXP);
    const translated = children.slice(0, 1);
    for (let i = 1; i < children.length; i++) {
        const child = children[i];
        translated.push(TRANSLATE_REG_EXP.test(child) ? replacements[children[++i]] : child);
    }
    return translated;
});
export const $ = (name, attributes = {}, children = [], doc = document) => {
    const element = doc.createElement(name);
    setAttributes(element, attributes);
    appendChildren(element, Array.isArray(children) ? children : [children], doc);
    return new ElementDecorator(element);
};
export const text = (str, doc = document) => intersperse(() => new ElementDecorator(doc.createElement('br')), str.split('\n'));
export const ps = (str, attrs = {}, doc = document) => str.split('\n').map((para) => $('p', attrs, para));
